import clsx from "clsx";
import Link from "next/link";

import { Shortcut } from "@components/Shortcut";
import { shouldRemoveBorder } from "@utils/teaserHelper/teaserHelper";

import { Context } from "types/context/Context";

import {
  ShortCutsBlockType_shortCutsBlock,
  ShortCutsBlockType_shortCutsBlock_linksCollection_items,
} from "./queries/contentfulTypes/ShortCutsBlockType";
import shortCutsStyles from "./shortCuts.module.css";
import { shortCutsTracker } from "./shortCutsTracker";

interface IShortCutsBlockProps {
  blockData: ShortCutsBlockType_shortCutsBlock;
  context?: Context;
}

export type ShortcutIconObject = {
  iconId: string;
  backgroundColor: string | null;
};

export const ShortCutsBlock = ({ blockData: shortCuts, context }: IShortCutsBlockProps) => {
  const hasColoredContext = shouldRemoveBorder(context);

  return (
    <section
      className={clsx(shortCutsStyles.shortCuts, {
        [shortCutsStyles.shortCutsInSection]: context?.sectionBlock,
      })}
      data-contentful-entry-id={shortCuts.sys.id}
      data-contentful-field-id="name"
    >
      <ul
        className={clsx(shortCutsStyles.list, {
          [shortCutsStyles.oneColumns]: shortCuts.columns === 1,
          [shortCutsStyles.twoColumns]: shortCuts.columns === 2 || shortCuts.columns === null,
          [shortCutsStyles.threeColumns]: shortCuts.columns === 3,
        })}
        data-blockname="snabblänkar"
      >
        {shortCuts?.linksCollection?.items?.map(
          (item: ShortCutsBlockType_shortCutsBlock_linksCollection_items, index: number) => {
            const itemUrl = item?.url;
            const linkToInsurance = shortcutToWhatInsurance(itemUrl);
            return (
              <li key={index}>
                <Link
                  href={itemUrl}
                  prefetch={false}
                  className={shortCutsStyles.link}
                  onClick={() =>
                    shortCutsTracker(
                      item?.linkText,
                      context?.sectionBlock?.sectionBlockHeading,
                      context?.sectionBlock?.sectionBlockIndex,
                      itemUrl,
                      linkToInsurance
                    )
                  }
                >
                  <Shortcut
                    icon={item?.shortcutIconObject as ShortcutIconObject}
                    label={item?.linkText}
                    text={item?.shortcutText}
                    removeContentBorder={hasColoredContext}
                    useIconBorder={hasColoredContext}
                  />
                </Link>
              </li>
            );
          }
        )}
      </ul>
    </section>
  );
};

function shortcutToWhatInsurance(url: string) {
  if (url.includes("/forsakring-vid-dodsfall")) return "tgl - tjänstegrupplivförsäkring";
  if (url.includes("/sjukforsakring")) return "ags - sjukforsäkring";
  if (url.includes("/arbetsskadeforsakring")) return "tfa/psa - arbetsskadeförsäkring";
  if (url.includes("/foraldrapenningtillagg")) return "fpt - föräldrapenningtillägg";
  if (url.includes("/forsakring-vid-arbetsbrist-agb")) return "agb - arbetsbrist";
  return "N/A";
}

export default ShortCutsBlock;
